import { useNavigate } from "react-router-dom";

import {
  Button,
  Link as DSLink,
  DuotoneIcon,
  Heading,
  Span,
} from "@icg360/design-system";

import { Stack } from "components/common/stack";
import { useHideFeedbackTab, useHideSupportChat } from "utils";

import styles from "./ting-enrolled.module.scss";

export const TingEnrolled = () => {
  useHideSupportChat();
  useHideFeedbackTab();
  const navigate = useNavigate();
  return (
    <div className={styles.layoutWrapper}>
      <Stack className={styles.content}>
        <DuotoneIcon name="Done" size="lg" />
        <Stack gap="sm">
          <Heading size="md">You&apos;re all set!</Heading>
          <Span>
            Once we process your order, Ting will email you with your shipment
            information. If you have any questions, check out{" "}
            <DSLink
              href="https://sagesure.widen.net/s/8hrmchdnzx/sagesure-ting-policyholder-faq"
              target="_blank"
            >
              Ting&apos;s FAQs
            </DSLink>
            .
          </Span>
        </Stack>
        <Button onPress={() => navigate("/my/property")}>
          Go to my SageSure account
        </Button>
      </Stack>
    </div>
  );
};
